import { render } from "./AdminService.vue?vue&type=template&id=023e4a38"
import script from "./AdminService.vue?vue&type=script&lang=js"
export * from "./AdminService.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yao/Documents/projects/garden/garden_ts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__